import { EbCommentOnContentPackageMeta, EbCommentOnContentPackagePayload } from 'types/store/EbCommentOnContentPackage';
import { createAsyncAction } from 'utils/Redux';

const ns = 'EB_COMMENT_ON_CONTENT_PACKAGE_NS';

const asyncAction = createAsyncAction<EbCommentOnContentPackageMeta, EbCommentOnContentPackagePayload>(ns);

const ebCommentOnContentPackageActions = { ...asyncAction };

export default ebCommentOnContentPackageActions;
